import React from "react";
import PropTypes from "prop-types";
import Styles from "./styles.scss";

const IconTextButton = ({ children, href, onClick, classes, testId }) => {
    // if provided a href in the props then returns anchor, otherwise returns button
    if (href) {
        return (
            <a className={`icon-text-button ${classes}`} href={href}>
                <style jsx>{Styles}</style>
                {children}
            </a>
        );
    }
    return (
        <button className={`icon-text-button ${classes}`} onClick={onClick} data-testid={testId}>
            <style jsx>{Styles}</style>
            {children}
        </button>
    );
};

IconTextButton.propTypes = {
    onClick: PropTypes.func,
    href: PropTypes.string,
    classes: PropTypes.string
};

IconTextButton.defaultProps = {
    onClick: null,
    href: "",
    classes: ""
};

export default IconTextButton;
